
<template>
<!-- 导入试卷制卡 -->
  <div class="doc-upload-wrapper">
    <el-dialog
      title="导入试卷制卡"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleCancel"
      @close="closeDialog"
      custom-class="doc_upload_import"
      >
      <div class="before_upload_step" v-if="beforeUpload">
        <span style="margin-right: 12px;color: #f56c6c;font-size: 12px;">*</span>
        <el-select v-model="formdata.subject" placeholder="请选择科目">
          <el-option
            v-for="item in formdata.subjectOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-upload
          class="upload_demo"
          drag
          action=""
          :file-list="fileList"
          :http-request="uploadSectionFile"
          :before-upload="handlerBeforeUpload"
          :auto-upload="true"
          :show-file-list="false"
          accept=".doc,.docx"
          ref="uploadRefs"
          >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            <el-button type="primary" size="small">点击上传</el-button>
          </div>
          <div class="el-upload__tip" slot="tip">注: 仅支持word格式（*.doc / docx）文件</div>
        </el-upload>
      </div>
      <div class="after_upload_step"  v-if="afterUpload">
       <el-progress :percentage="uploadPercent" :status="uploadCompleted ?( uploadSuccess ? 'success' : 'exception') : ''" :stroke-width="5" :width='180'  type="circle"></el-progress>
       <p style="margin-top: 18px">{{this.progressTxt}}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel('cancel')">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AcCardApi from "@/services/acCard"
import { mapState, mapMutations } from "vuex";
export default {
  props:{
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
  ...mapState("card", {
    kMAndPeriod: (state) => state.kMAndPeriod, //学科和学段的字典
    }),
  },
  data() {
    return {
      formLabelWidth: '100px',
      dialogVisible: false,
      beforeUpload: true,
      afterUpload: false,
      uploadPercent: 0,
      uploadSuccess: false,
      uploadCompleted: false,
      progressTxt: '上传解析中',
      fileList: [],
      formdata: {
        subject: '', // 科目
        subjectOptions: [{
          value: 1,
          label: '数学'
        },{
          value: 2,
          label: '物理'
        },{
          value: 3,
          label: '化学'
        },{
          value: 4,
          label: '政治'
        },{
          value: 5,
          label: '历史'
        },{
          value: 6,
          label: '生物'
        },{
          value: 7,
          label: '地理'
        },{
          value: 8,
          label: '英语'
        },{
          value: 9,
          label: '语文'
        },], // 科目
      },
    }
  },
  methods: {
    async handleSubmit(formName) {
    },
    closeDialog(){
      this.$emit('input', false);
      this.fileList = [];
      this.beforeUpload = true;
      this.afterUpload = false;
      this.formdata.subject = '';
      this.initProgress();
    },
    handleCancel() {
      // this.uploadCompleted && (this.dialogVisible = false);
      if(this.beforeUpload || this.uploadCompleted) {
        this.dialogVisible = false
      }
    },
    handleChange(file) {
      // file ? this.handleUpload(file) :null;
    },
    /**
     * 覆盖自定义上传
     * @param {object} target 一个带有file上传文件等其他属性的对象
     */
    async uploadSectionFile(target) {
      if(!this.formdata.subject) {
        return this.$message({
          type: 'warning',
          message: '请先选择科目！'
        })
      }
      this.toggleUploadStatus();
      let formdata = new FormData();
      formdata.append('', target.file);
      console.log(this.$refs.uploadRefs.onProgress,'dsaddvonProgressonProgress');
      this.mockUploadProgress(this.uploadCompleted);
      this.mockUploadProgressTxt(this.uploadCompleted)
      let result = await AcCardApi.UploadFileDoc(formdata,{
        subject: this.formdata.subject,
      });
      this.uploadCompleted = true;
      if(result.status == 200) {
        this.uploadSuccess = true;
        this.progressTxt = '解析完成 即将跳转到答题卡！';
        const timer = setTimeout(() => {
          this.$router.push({
            path: '/card',
            query: {
              guid: result.data.Guid
            }
          });
          clearTimeout(timer);
        }, 1500);
      } else {
        this.uploadSuccess = false;
        this.progressTxt = result.message;
      }
    },
    handlerBeforeUpload(file) {
    },
    /**
     */
    toggleUploadStatus() {
      this.beforeUpload = false;
      this.afterUpload = true;
    },
    /**
     * 设置上传进度
     */
    setPercent(uploadPercent) {
      this.uploadPercent = uploadPercent;
    },
    /**
     * 前端模拟上传进度
     * @returns {void} 
     */
    mockUploadProgress() {
      const timer = setInterval(() => {
        if(!this.uploadCompleted) {
          if(this.uploadPercent <= 60) {
         this.uploadPercent += 4;
         this.setPercent(this.uploadPercent);
        } else if (this.uploadPercent >= 60 && this.uploadPercent <= 90) {
         this.uploadPercent += 1;
         this.setPercent(this.uploadPercent);
        }
        } else {
         this.setPercent(100);
         clearInterval(timer);
        }
      }, 60)
    },
    /**
     * 模拟上传文件进度 文字提醒
     * @returns {string} 返回文字进度提醒
     */
    mockUploadProgressTxt() {
      const timer = setInterval(() => {
      if(!this.uploadCompleted) {
        if(this.progressTxt.length < 8) {
          this.progressTxt += '.';
        } else {
          this.progressTxt = this.progressTxt.substr(0, this.progressTxt.length -3);
        }
      } else {
        clearInterval(timer);
      }
      }, 600)
    },
    /**
     * 初始化进度条属性
     * @returns {void} 
     */
    initProgress() {
      this.uploadCompleted = false;
      this.uploadPercent = 0;
      this.progressTxt = '上传解析中';
    }
  },
  watch: {
    value(newVal) {
      if(newVal) {
        this.dialogVisible = true;
      }
    },
  },
  mounted() {
  }
}
</script>

<style lang="scss" >
.doc-upload-wrapper{
.el-select .el-input{
  width: 300px !important;
}
.el-input-group__append{
  background-color: #66b1ff;
  color: #fff;
  border: 1px solid #66b1ff;
}
.before_upload_step{
  text-align: center;
}
.after_upload_step{
  text-align: center;
}
.upload_demo{
  margin-top: 12px;
}
.progress_wrap{
  width: 400px;
  margin: 0 auto;
}
}
.doc_upload_import{
min-height: 445px !important;
.el-form-item span{
  padding: 0;
}
.el-dialog__footer{
    position: absolute;
    bottom: 20px;
    right: 10px;
}
.el-upload__tip{
  color: #D7D7D7 !important;
}
}

</style>